import { RenewVisaHistoryCompanyApplicationPage } from "@/features/renew-visa/pages/RenewVisaHistoryCompanyApplication";

const RenewVisaHistoryCompanyApplication = () => {
  return <RenewVisaHistoryCompanyApplicationPage />;
};

export default RenewVisaHistoryCompanyApplication;
